import { modules } from '@veritone/glc-redux';
const {
  config: { getConfig },
} = modules;

const getEngineIdBulkTag = (state: any) => {
  const config = getConfig<Window['config']>(state);
  return config.engineIdBulkTag;
};
export default getEngineIdBulkTag;
